import React from "react";
import { ArrowRight } from "lucide-react";
import NexusLogo from "../core/NexusLogo";

const HomePage = ({ onNavigate }) => {
  return (
    <div className="max-w-6xl mx-auto h-screen flex flex-col justify-center items-center p-6">
      <NexusLogo className="w-1/3 h-auto mb-10" />

      <h1 className="text-4xl font-bold text-gray-900 text-center mb-6">
        Nexus: AI-Powered Migration Solution
      </h1>

      <p className="text-xl text-gray-600 text-center mb-12 max-w-3xl">
        Seamlessly migrate your legacy systems to Workday with our intelligent,
        AI-driven platform that reduces migration time by 75%.
      </p>

      <button
        type="button"
        onClick={() => onNavigate("modules")}
        className="px-8 py-4 bg-blue-600 text-white rounded-lg text-xl font-medium 
                  hover:bg-blue-700 transition-colors shadow-lg flex items-center"
      >
        Proceed
        <ArrowRight className="ml-2" size={24} />
      </button>
    </div>
  );
};

export default HomePage;
